import { createContext } from "react";

export const ArticulosColoresContext = createContext()
export const ArticulosColoresFormContext = createContext()
export const ArticulosColoresReportContext = createContext()